export default __webpack_public_path__ + "static/media/resendMessageIcon.23e25e94.svg";